
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.1 179.2H29c-2.4 0-4.5-1.2-5.6-3.2-1.1-1.9-1-4.3.1-6.2 3.5-5.9 6.9-17.2 7.9-23.3-14.7-14.3-22.8-32.6-22.8-51.7 0-6.1.8-12.2 2.5-18.2 3.3-11.9 10-23.1 19.2-32.4C47.7 26.7 73.1 16.6 100 16.6c24.3 0 47.1 8 64.3 22.6 17.5 14.8 27.1 34.5 27.1 55.5s-9.6 40.8-27.1 55.5c-17.2 14.6-40.1 22.6-64.3 22.6-13.6 0-27.2-2.6-39.4-7.6-8.8 7.2-21.5 14-31.5 14zM100 26.6c-24.2 0-47 9-62.6 24.6-8.1 8.1-13.9 17.8-16.7 28-1.4 5.1-2.1 10.3-2.1 15.5 0 17.1 7.6 33.5 21.5 46.1l1.8 1.6-.1 2.4c-.3 5.3-2.9 15.2-6.2 23.2 6.6-2.1 14.7-6.7 20.9-12.2l2.4-2.1 2.9 1.3c11.7 5.2 24.9 8 38.2 8 44.9 0 81.4-30.6 81.4-68.2S144.9 26.6 100 26.6z"}}),_c('path',{attrs:{"d":"M114 116.9l29.3-29.3c-1.5-1.5-3.4-2.3-5.4-2.5-3.9-5.1-8.7-10.6-14.1-16.1-5.4-5.4-11-10.3-16.1-14.1-.2-2-1-3.9-2.5-5.4L75.9 78.8c1.5 1.5 3.4 2.3 5.4 2.5 2.9 3.9 6.5 8.1 10.4 12.3l-30.8 30.8 6.2 6.2 30.8-30.8c4.6 4.5 9.3 8.4 13.6 11.6.1 2.1 1 4 2.5 5.5zM89.4 77.7L104 63.1c4.4 3.4 9 7.5 13.6 12.1s8.7 9.3 12.1 13.6l-14.6 14.6c-4.4-3.4-9-7.5-13.6-12.1S92.8 82 89.4 77.7z"}})])
          )
        }
      }
    